export const profile = {
	99: {
		label: 'Administrador',
		dashboard: true,
		chat: true,
		crm: true,
		flow: true,
		config: true,
		customer: true,
		workflow: true,
		campaign: true,
	},
	98: {
		label: 'API',
		dashboard: false,
		chat: false,
		crm: false,
		flow: false,
		config: false,
		customer: false,
		workflow: false,
		campaign: false,
	},
	9: {
		label: '',
		dashboard: true,
		chat: true,
		crm: true,
		flow: true,
		config: false,
		customer: true,
		workflow: false,
		campaign: true,
	},
	8: {
		label: 'Marketing',
		dashboard: true,
		chat: true,
		crm: false,
		flow: true,
		config: false,
		customer: true,
		workflow: false,
		campaign: true,
	},
	7: {
		label: 'Supervisor',
		dashboard: true,
		chat: true,
		crm: false,
		flow: false,
		config: false,
		customer: false,
		workflow: true,
		campaign: true,
	},
	6: {
		label: 'Dashboard',
		dashboard: true,
		chat: false,
		crm: false,
		flow: false,
		config: false,
		customer: false,
		workflow: false,
		campaign: false,
	},
	5: {
		label: 'Monitor',
		dashboard: false,
		crm: false,
		flow: false,
		config: false,
		customer: false,
		chat: true,
		workflow: true,
		campaign: false,
	},
	4: {
		label: 'Operador N3',
		dashboard: false,
		chat: true,
		crm: false,
		flow: false,
		config: false,
		customer: true,
		workflow: true,
		campaign: false,
	},
	3: {
		label: 'Backoffice',
		dashboard: false,
		chat: false,
		crm: false,
		flow: false,
		config: false,
		customer: false,
		workflow: true,
		campaign: false,
	},
	2: {
		label: 'Operador N2',
		dashboard: false,
		crm: false,
		flow: false,
		config: false,
		customer: false,
		chat: true,
		workflow: true,
		campaign: false,
	},
	1: {
		label: 'Operador',
		dashboard: false,
		crm: false,
		flow: false,
		config: false,
		customer: false,
		chat: true,
		workflow: true,
		campaign: false,
	},
	10: {
		label: 'Operador N4',
		dashboard: false,
		crm: false,
		flow: false,
		config: false,
		customer: true,
		chat: true,
		workflow: true,
		campaign: false,
	},
}
